export type DeliveryRatingInput = {
  collectedSpeedBoosters: number;
  targetSpeedBoosterCount: number;
  collectedSparks: number;
  targetSparkCount: number;
  collisions: number;
};

export type DeliveryRatingBreakdown = {
  timeScore: number;
  sparkScore: number;
  skillScore: number;
  totalScore: number;
  isPerfect: boolean;
};

export const TIME_SCORE_MAX = 2;
export const SPARK_SCORE_MAX = 2;
export const SKILL_SCORE_MAX = 1;
export const TOTAL_SCORE_MAX = 5;
/** Шкала строк на экране результата. */
export const STAT_DISPLAY_MAX = 5;

function clamp01(v: number): number {
  return Math.min(1, Math.max(0, v));
}

function round1(v: number): number {
  return Math.round(v * 10) / 10;
}

/** Внутренний балл (2 / 2 / 1) → отображение «из 5». */
export function scaleScoreToDisplayMax(score: number, internalMax: number): number {
  if (internalMax <= 0) {
    return STAT_DISPLAY_MAX;
  }
  return round1((score / internalMax) * STAT_DISPLAY_MAX);
}

export function calculateDeliveryRating(input: DeliveryRatingInput): DeliveryRatingBreakdown {
  const safeSpeedBoosters = Math.max(0, input.collectedSpeedBoosters);
  const safeSparks = Math.max(0, input.collectedSparks);
  const safeCollisions = Math.max(0, input.collisions);

  const timeRatio = input.targetSpeedBoosterCount > 0
    ? clamp01(safeSpeedBoosters / input.targetSpeedBoosterCount)
    : 1;
  const sparkRatio = input.targetSparkCount > 0
    ? clamp01(safeSparks / input.targetSparkCount)
    : 1;
  const skillRatio = clamp01(1 - safeCollisions / 3);

  const timeScore = round1(timeRatio * TIME_SCORE_MAX);
  const sparkScore = round1(sparkRatio * SPARK_SCORE_MAX);
  const skillScore = round1(skillRatio * SKILL_SCORE_MAX);
  const totalScore = round1(Math.min(TOTAL_SCORE_MAX, timeScore + sparkScore + skillScore));

  return {
    timeScore,
    sparkScore,
    skillScore,
    totalScore,
    isPerfect: totalScore === TOTAL_SCORE_MAX,
  };
}
